/*
 * @description:
 * @author: Jason Wong
 * @since: 2023-01-11 15:01:27
 */

const replace = document.createElement("div");

class domHelper {
    static t(text) {
        return document.createTextNode(t);
    }

    /**
     *
     * @param {Node} el
     * @returns
     */
    static isText(el) {
        return !!el && el.nodeType == Node.TEXT_NODE;
    }

    static text(content) {
        document.createDocumentFragment();
        return document.createTextNode(content);
    }

    static emptyText() {
        return this.text(String.fromCodePoint(0x200b));
    }

    /**
     *
     * @param {Node} node
     * @returns
     */
    static isEle(node) {
        return node.nodeType == Node.ELEMENT_NODE;
    }

    /**
     *
     * @param {String} tag
     * @param {Object} options
     * @param {Array<Element>} childs
     * @returns
     */
    static ele(tag, options, childs) {
        let el = document.createElement(tag);

        let ell = document.createElement("div");
        if (options != null) {
            for (const attr in options.attrs || {}) {
                el.setAttribute(attr, options.attrs[attr]);
            }

            for (const cl of options.classes || []) {
                el.classList.add(cl);
            }

            if (!!options.styles) {
                if (typeof options.styles == "string") {
                    this.attr(el, "style", options.styles);
                } else {
                    for (const sty in options.styles || {}) {
                        el.style[sty] = options.styles[sty];
                    }
                }
            }
        }

        (childs || []).forEach((c) => {
            el.appendChild(c);
        });

        return el;
    }

    /**
     *
     * @param {Node} node
     */
    static hasChild(node) {
        return node.childNodes.length > 0;
    }

    /**
     *
     * @param {*} options
     * @param {*} childs
     * @returns HTMLDivElement
     */
    static div(options, childs) {
        return this.ele("div", options, childs);
    }

    /**
     *
     * @param {Element} el
     * @param {String} tagName
     * @returns
     */
    static are(el, tagName) {
        if (!el) throw new Error("el can not be null.");
        if (!tagName) throw new Error("tagName can not be null.");
        return !!el.tagName && el.tagName.toLocaleLowerCase() == tagName.toLocaleLowerCase();
    }

    static hasCls(el, ...cls) {
        if (!el) throw new Error("El can not be null");
        if (!cls || cls.length < 1) throw new Error("cls can not be empty");

        if (!el.classList) return false;
        for (let i = 0; i < cls.length; i++) {
            const cname = cls[i];
            if (!el.classList.contains(cname)) return false;
        }
        return true;
    }

    /**
     *
     * @param {Element} el
     * @param {String} attrName
     * @param {String} attrValue
     * @returns
     */
    static attr(el, attrName, attrValue) {
        if (!el || !el.getAttribute) return null;

        if (!attrValue) {
            return el.getAttribute(attrName);
        } else {
            el.setAttribute(attrName, attrValue);
        }
    }

    /**
     * remove attribute from node
     * @param {Element} node
     * @param {String} name
     */
    static removeAttr(node, name) {
        if (!node) throw new Error("node can not be null");
        if (!(node instanceof Element)) throw new Error("node must be a node element");
        if (!name) throw new Error("name can not be null");

        if (node.hasAttribute(name)) node.removeAttribute(name);
    }

    static getRange() {
        const sel = window.getSelection();
        return sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
    }

    /**
     *
     * @param {DocumentFragment} fragment
     */
    static fragmentToArray(fragment) {
        if (!fragment || fragment.childNodes.length < 1) return [];
        let res = [];
        for (let i = 0; i < fragment.childNodes.length; i++) {
            res.push(fragment.childNodes[i]);
        }
        return res;
    }

    static replaceSelectionRange(range) {
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
    }

    static setRangeBefore(node) {
        if (!node) return;
        const range = document.createRange();
        range.setStartBefore(node);
        range.setEndBefore(node);
        this.replaceSelectionRange(range);
    }

    static setRangeAfter(node) {
        if (!node) return;

        const range = document.createRange();
        range.setStartAfter(node);
        range.setEndAfter(node);
        this.replaceSelectionRange(range);
    }

    static setRangeAt(node, pos) {
        if (!node) return;

        const range = document.createRange();
        range.setStart(node, pos);
        range.setEnd(node, pos);
    }

    static setRangeInText(text, pos) {
        if (!text) return;

        const range = document.createRange();
        range.setStart(text, pos);
        range.setEnd(text, pos);
        this.replaceSelectionRange(range);
    }

    /**
     *
     * @param {Node} node
     * @param {Range} range
     */
    static moveChildToRange(node, range) {
        while (node.childNodes.length > 0) {
            range.insertNode(node.lastChild);
        }
    }

    /**
     *
     * @param {Node} sourceNode
     * @param {Node} targetNode
     */
    static moveChildToNode(sourceNode, targetNode) {
        while (sourceNode.childNodes.length > 0) {
            targetNode.appendChild(sourceNode.firstChild);
        }
    }

    /**
     *
     * @param {Element} el
     * @param {Object} eventHandler
     */
    static on(el, eventHandler) {
        if (!el || !eventHandler) return;

        const methodStartsOn = filterMethodStartsOn(eventHandler);
        for (const pair of methodStartsOn) {
            el.addEventListener(pair.event, pair.handler);
        }
        return methodStartsOn;
    }

    /**
     *
     * @param {Element} el
     * @param {Array<EventHandler>} handles
     */
    static off(el, handlers) {
        if (!el || !handlers) return;
        for (const pair of handlers) {
            el.removeEventListener(pair.event, pair.handler);
        }
    }

    static isAncestorOf(ancestor, child) {
        if (!ancestor || !child) return;

        let curEl = child;
        while (curEl) {
            if (curEl == ancestor) return true;
            curEl = curEl.parentNode;
        }

        return false;
    }

    /**
     *
     * @param {Node} node
     * @param {Node} untilNode
     */
    static findFarthestAncestorUntil(node, untilNode) {
        untilNode = untilNode || document.body;
        let curNode = node;
        while (!!curNode && curNode.parentNode != untilNode) {
            curNode = curNode.parentNode;
        }
        return curNode;
    }

    /**
     *
     * @param {Element} newNode
     * @param {Node} child
     */
    static insertBefore(newNode, child) {
        child.parentNode.insertBefore(newNode, child);
    }

    /**
     *
     * @param {Node} newNode
     * @param {Node} child
     */
    static insertAfter(newNode, child) {
        if (!newNode) throw new Error("newNode can not be null.");
        if (!child) throw new Error("child can not be null");
        if (!child.parentNode) throw new Error("child has no parent");
        if (!!child.nextSibling) child.parentNode.insertBefore(newNode, child.nextSibling);
        else child.parentNode.append(newNode);
    }

    static canCombine(leftNode, rightNode) {
        if (
            !leftNode ||
            leftNode.nodeType != Node.ELEMENT_NODE ||
            !rightNode ||
            rightNode.nodeType != Node.ELEMENT_NODE
        ) {
            return false;
        }
        if (leftNode.tagName != leftNode.tagName) return false;
        for (let i = 0; i < leftNode.attributes.length; i++) {
            const attr = leftNode.attributes[i];
            if (attr.value != rightNode.getAttribute(attr.name)) {
                return false;
            }
        }
        return true;
    }

    /**
     * create a document element filled with given text
     * @param {*} nodeName
     * @param {*} text
     */
    static createElementWithText(nodeName, txt) {
        if (nodeName == "#text") {
            return document.createTextNode(txt);
        } else {
            const el = document.createElement(nodeName);
            const text = document.createTextNode(txt);
            el.appendChild(text);
            return el;
        }
    }

    /**
     * get current range(In firefox,just fetching the first one)
     */
    static getRange() {
        const selection = window.getSelection();
        return !!selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
    }

    static isDel(element) {
        return this.are(element, "del");
    }

    static isIns(element) {
        return this.are(element, "ins");
    }
}

class EventHandler {
    constructor(event, handler) {
        this.event = event;
        this.handler = handler;
    }
}

function filterMethodStartsOn(eventHandler) {
    window.ell = eventHandler;
    let res = [];
    let curObj = eventHandler;
    while (curObj) {
        for (const name of Object.getOwnPropertyNames(curObj)) {
            if (!name.startsWith("on") || !(eventHandler[name] instanceof Function)) continue;

            const tempName = name.substring(2).trim();
            if (tempName.length < 1) continue;
            res.push(new EventHandler(tempName, eventHandler[name].bind(eventHandler)));
        }
        curObj = Object.getPrototypeOf(curObj);
    }
    return res;
}

const KEY_CODES = {
    DOM_VK_BACK_SPACE: 0x08,
    Delete: 0x2e,
    Enter: 0x0d,
};

const INPUT_TYPE = {
    deleteContentBackward: "deleteContentBackward",
    deleteByCut: "deleteByCut",
    insertText: "insertText",
    insertFromPaste: "insertFromPaste",
    insertCompositionText: "insertCompositionText",

    //custome types
    paste: "paste",
    composition: "composition",
};

export default domHelper;
export { KEY_CODES, INPUT_TYPE };